export interface ArticleContent {
  blocks: ArticleContentBlocks[];
}

export enum ArticleContentBlockTypes {
  Title = 'Title',
  MainIdea = 'MainIdea',
  RichText = 'RichText',
  RawHTML = 'RawHTML',
  Image = 'Image',
  Quote = 'Quote',
  WebinarBanner = 'WebinarBanner',
  ProductBanner = 'ProductBanner',
  Video = 'Video',
}

type ArticleContentBlocks =
  | TitleBlock
  | MainIdeaBlock
  | RichTextBlock
  | RawHTML
  | ImageBlockBlock
  | QuoteBlockBlock
  | WebinarBannerBlock
  | ProductBannerBlock
  | VideoBlock;

export type VideoBlock = {
  type: ArticleContentBlockTypes.Video;
  link: string;
  previewImage: string;
};

export type TitleBlock = {
  type: ArticleContentBlockTypes.Title;
  title: string;
  id: string;
};

export type MainIdeaBlock = {
  type: ArticleContentBlockTypes.MainIdea;
  title: string;
  description: string;
};

export type RichTextBlock = {
  type: ArticleContentBlockTypes.RichText;
  richText: string;
};

export type RawHTML = {
  type: ArticleContentBlockTypes.RawHTML;
  html: string;
};

export type ImageBlockBlock = {
  type: ArticleContentBlockTypes.Image;
  src: string;
  alt: string;
  description: string;
};

export type QuoteBlockBlock = {
  type: ArticleContentBlockTypes.Quote;
  text: string;
  author: string;
  post: string;
};

export type WebinarBannerBlock = {
  type: ArticleContentBlockTypes.WebinarBanner;
  title: string;
  description: string;
  time: string;
  button: {
    text: string;
    url: string;
  };
};

export type ProductBannerBlock = {
  type: ArticleContentBlockTypes.ProductBanner;
  title: string;
  description: string;
  image: {
    src: string;
    alt: string;
    description: string;
  };
  button: {
    text: string;
    url: string;
  };
};
